import { render, staticRenderFns } from "./ConstructionFormInfo.vue?vue&type=template&id=61031c22&"
import script from "./ConstructionFormInfo.vue?vue&type=script&lang=js&"
export * from "./ConstructionFormInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports